import { Header } from "@react-navigation/elements";
import {
  ComponentInstantiator,
  ComponentInstantiatorProps,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { View } from "react-native";
import { Colors } from "react-native-ui-lib";

export interface PlaceholderLoadingScreenProps {
  navigation: any;
  modifyHeader?: boolean;
  headerShownAfterTansition?: boolean;
  content: ComponentInstantiatorProps["Component"];
  headerShown?: boolean;
}
export const PlaceholderLoadingScreen = ({
  content,
  headerShown = true,
}: any) => {
  /**
   * Replicate the header otherwise the real header will blink
   */
  const header = headerShown && (
    <View style={{ position: "absolute", width: "100%", marginBottom: 64 }}>
      <Header
        modal={true}
        title={""}
        headerLeft={() => <ModalCloseButton type="Back" />}
        headerLeftContainerStyle={{
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: 20,
        }}
        headerTitleContainerStyle={{
          justifyContent: "center",
          alignItems: "center",
        }}
        headerStyle={{
          backgroundColor: Colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: Colors.borderColor,
          paddingLeft: 20,
          paddingRight: 20,
        }}
      />
    </View>
  );

  return (
    <View>
      {header}
      <View style={{ marginTop: 64 }}>
        <ComponentInstantiator Component={content} />
      </View>
    </View>
  );
};
